export default "__VITE_ASSET__CB$nSWiA__"